export default __webpack_public_path__ + "static/media/ecran_2_je_rejoins_FR.c1035c35.png";